import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryComponent } from './gallery.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [GalleryComponent],
	exports: [GalleryComponent],
	imports: [
		CommonModule,
		FormsModule,
		IonicModule.forRoot(),
		FlexLayoutModule,
		TranslateModule
	],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GalleryModule { }
